import React, { ReactNode, createContext, useContext } from 'react';
import ServiceList from '../pages/ServiceList';
import ConsultAppointment from '../pages/ConsultAppointment';
import AppointmentDetails from '../pages/AppointmentDetails';
import { Upload } from '../pages/Upload';
import { UnitAuxiliaryInfo } from '../pages/UnitAuxiliaryInfo';
import { CheckUpRouter } from '../flows/CheckUp';
import { ExecutiveCheckupRouter } from '../flows/ExecutiveCheckup';
import { GeneralRouter } from '../flows/General';
import { TelemedicinePA } from '../flows/TelemedicinePA';
import { BloodBankRouter } from '../flows/BloodBank';
import { CaplusRouter } from '../flows/CarePlus';

export enum Page {
  SERVICE_LIST = 'SERVICE_LIST',
  CONSULT_APPOINTMENT = 'CONSULT_APPOINTMENT',
  UPLOAD = 'UPLOAD',
  APPOINTMENT_DETAILS = 'APPOINTMENT_DETAILS',
  UNIT_AUXILIARY_INFO = 'UNIT_AUXILIARY_INFO',
  CHECKUP_DIGITAL_ROUTER = 'CHECKUP_DIGITAL_ROUTER',
  CHECKUP_EXECUTIVE_ROUTER = 'CHECKUP_EXECUTIVE_ROUTER',
  TELEMEDICINE_PA = 'TELEMEDICINE_PA',
  GENERAL = 'GENERAL',
  BLOOD_BANK = 'BLOOD_BANK',
  CARE_PLUS = 'CAREPLUS'
}

export const Pages: Record<Page, { component: (props: any) => JSX.Element; title: string }> = {
  [Page.SERVICE_LIST]: { component: ServiceList, title: 'Escolha o produto' },
  [Page.UPLOAD]: { component: Upload, title: 'Upload' },
  [Page.CONSULT_APPOINTMENT]: { component: ConsultAppointment, title: '' },
  [Page.APPOINTMENT_DETAILS]: { component: AppointmentDetails, title: '' },
  [Page.UNIT_AUXILIARY_INFO]: { component: UnitAuxiliaryInfo, title: '' },
  [Page.CHECKUP_DIGITAL_ROUTER]: { component: CheckUpRouter, title: 'Check-up Digital' },
  [Page.CHECKUP_EXECUTIVE_ROUTER]: { component: ExecutiveCheckupRouter, title: 'Check-up Executivo' },
  [Page.TELEMEDICINE_PA]: { component: TelemedicinePA, title: 'Einstein Conecta' },
  [Page.GENERAL]: { component: GeneralRouter, title: '' },
  [Page.BLOOD_BANK]: { component: BloodBankRouter, title: '' },
  [Page.CARE_PLUS]: { component: CaplusRouter, title: '' }
};

type RouterHistory = {
  index: number;
  page: Page;
  component: ReactNode;
  params: Record<string, unknown>;
};

export interface IMainRouterContext {
  navigate: (page: Page, params?: Record<string, unknown>) => void;
  goBack: () => void;
  history: RouterHistory[];
}

export const MainRouterContext = createContext<IMainRouterContext>({
  navigate: () => void 0,
  goBack: () => void 0,
  history: []
});

export function useMainRouter() {
  return useContext(MainRouterContext);
}
